<!--企业简介-->
<template>
  <el-row class="hei100 flex-column">
    <el-row style="padding-top:34px;padding-bottom:0;" :class="Calink!=1?'bgc-wt boxshadow':'bgc-blue2'">
      <el-row>
        <div class=" absolute" style="left:100px;top:14px;">
          <div class=" pointer" :class="Calink==1?'reback2':'reback'" @click="backUrl()"><span>返回首页</span></div>
        </div>
        <el-row class="auto text-center" :class="Calink==1?'company-menu2':'company-menu'" style="width:1300px;"
          type="flex">
          <div class="flexson" :class="Calink==1?'onclick':''" @click="Calink=1">
            <a href="#Cpart1"><span>企业简介</span></a>
          </div>
          <div class="flexson" :class="Calink==2?'onclick':''" @click="Calink=2">
            <a href="#Cpart2"><span>核心团队</span></a>
          </div>
          <div class="flexson" :class="Calink==3?'onclick':''" @click="Calink=3">
            <a href="#Cpart7"><span>企业文化</span></a>
          </div>
          <div class="flexson" :class="Calink==4?'onclick':''" @click="Calink=4">
            <a href="#Cpart3"><span>发展历程</span></a>
          </div>
          <div class="flexson" :class="Calink==5?'onclick':''" @click="Calink=5">
            <a href="#Cpart4"><span>企业要闻</span></a>
          </div>
          <div class="flexson" :class="Calink==6?'onclick':''" @click="Calink=6">
            <a href="#Cpart5"><span>企业荣誉</span></a>
          </div>
          <div class="flexson" :class="Calink==7?'onclick':''" @click="Calink=7">
            <a href="#Cpart6"><span>合作伙伴</span></a>
          </div>
        </el-row>
      </el-row>
    </el-row>
    <!--  -->
    <el-row class="flex-son">
      <el-row class="absoluteCont overauto" id="wrap">
        <div id="Cpart1" class=" bgc-blue2" style="padding-bottom:40px;">
          <img class="block auto" src="../../assets/company/company-1.png" alt="">
        </div>
        <!-- part1 -->
        <el-row class=" " style="">
          <div class="">
            <img class="block wid100" src="../../assets/company/company-2.png" alt="">
          </div>
        </el-row>
        <!-- part2 -->
        <el-row>
          <div id="Cpart2" class="">
            <img class="block wid100" src="../../assets/company/company-3.png" alt="">
          </div>
          <div id="Cpart7" class="absoluteBtm" style="bottom:250px;"></div>
        </el-row>
        <!-- part3 -->
        <el-row id="Cpart3" class=" " style="">
          <div class="">
            <img class="block wid100" src="../../assets/company/company-4.png" alt="">
          </div>
        </el-row>
        <!-- part4 -->
        <el-row id="Cpart4" class=" " style="">
          <div class="">
            <img class="block wid100" src="../../assets/company/company-5.png" alt="">
          </div>
        </el-row>
        <!-- part5 -->
        <el-row id="Cpart5" class=" " style="">
          <div class="">
            <img class="block wid100" src="../../assets/company/company-6.png" alt="">
          </div>
        </el-row>
        <!-- part6 -->
        <el-row id="Cpart6" style="">
          <div class="">
            <img class="block auto" src="../../assets/company/company-7.png" alt="">
          </div>
          <el-row class="auto" style="width:76%;">
            <div class=" fl wid20 pading-left20 pading-top20">
              <img class="block wid100" src="../../assets/images/partner1.png" alt="">
            </div>
            <div class=" fl wid20 pading-left20 pading-top20">
              <img class="block wid100" src="../../assets/images/partner2.png" alt="">
            </div>
            <div class=" fl wid20 pading-left20 pading-top20">
              <img class="block wid100" src="../../assets/images/partner3.png" alt="">
            </div>
            <div class=" fl wid20 pading-left20 pading-top20">
              <img class="block wid100" src="../../assets/images/partner4.png" alt="">
            </div>
            <div class=" fl wid20 pading-left20 pading-top20">
              <img class="block wid100" src="../../assets/images/partner5.png" alt="">
            </div>
            <div class=" fl wid20 pading-left20 pading-top20">
              <img class="block wid100" src="../../assets/images/partner6.png" alt="">
            </div>
            <div class=" fl wid20 pading-left20 pading-top20">
              <img class="block wid100" src="../../assets/images/partner7.png" alt="">
            </div>
            <div class=" fl wid20 pading-left20 pading-top20">
              <img class="block wid100" src="../../assets/images/partner8.png" alt="">
            </div>
            <div class=" fl wid20 pading-left20 pading-top20">
              <img class="block wid100" src="../../assets/images/partner9.png" alt="">
            </div>
            <div class=" fl wid20 pading-left20 pading-top20">
              <img class="block wid100" src="../../assets/images/partner10.png" alt="">
            </div>
            <div class=" fl wid20 pading-left20 pading-top20">
              <img class="block wid100" src="../../assets/images/partner11.png" alt="">
            </div>
            <div class=" fl wid20 pading-left20 pading-top20">
              <img class="block wid100" src="../../assets/images/partner12.png" alt="">
            </div>
            <div class=" fl wid20 pading-left20 pading-top20">
              <img class="block wid100" src="../../assets/images/partner13.png" alt="">
            </div>
            <div class=" fl wid20 pading-left20 pading-top20">
              <img class="block wid100" src="../../assets/images/partner14.png" alt="">
            </div>
            <div class=" fl wid20 pading-left20 pading-top20">
              <img class="block wid100" src="../../assets/images/partner15.png" alt="">
            </div>
          </el-row>
        </el-row>
        <el-row style="height:60px;"></el-row>
        <footerbar></footerbar>
      </el-row>
    </el-row>
  </el-row>
</template>

<script>
import footerbar from "../footerbar";
export default {
  name: "company",
  components: { footerbar },
  data() {
    return {
      Calink: 1
    };
  },
  mounted() {
    document.querySelector("#wrap").addEventListener('scroll',this.handleScroll)
  },
  methods: {
    backUrl(){
      this.$router.push({path:'/index'})
    },
    handleScroll(){
      let scrollTop = document.querySelector("#wrap").scrollTop;
      scrollTop = 0;
      console.log(scrollTop);
      if(scrollTop>=3400){
        this.Calink = 7;
      }else  if(scrollTop>=2840){
        this.Calink = 6;
      }else if(scrollTop>=2300){
        this.Calink = 5;
      }else if(scrollTop>=1460){
        this.Calink = 4;
      }else if(scrollTop>=1000){
        this.Calink = 3;
      }else if(scrollTop>=340){
        this.Calink = 2;
      }else if(scrollTop<=242){
        this.Calink = 1;
      }
    },
    openUrl(n) {
      this.$router.push({ path: "/index" });
    },
    pushTorczp() {
      this.$router.push({ path: "/joinUs" });
    }
  },
  destroyed() {},
  watch: {}
};
</script>



// WEBPACK FOOTER //
// src/components/basicData/company.vue